import React, { useRef } from 'react'
import { IconSearch } from '@tabler/icons-react'

import { useMetaShortcut } from '@/utils/hooks/useMetaShortcut'

const isMac = typeof navigator !== 'undefined' && navigator.userAgent.includes('Mac')

export const SidebarSearch = ({ searchQuery, setSearchQuery }) => {
  const inputRef = useRef(null)

  useMetaShortcut('k', () => {
    inputRef.current.focus()
  })

  return (
    <div className="sidebar-search search-input">
      <input
        type="text"
        autoComplete="off"
        placeholder="Search pages"
        aria-label="Search pages"
        value={searchQuery}
        onChange={(event) => setSearchQuery(event.target.value)}
        data-testid="sidebar-search-input"
        ref={inputRef}
      />
      <IconSearch />
      <span className="keycap-hint">{isMac ? '⌘K' : 'Ctrl+K'}</span>
    </div>
  )
}
